<template>
  <div style="margin-top:10px">
    <div class="platform_div">
      <div class="platform_common_title">成本发票审核列表</div>
      <div>
        <el-date-picker class="picker_input" @change="init(1)" v-model="month" type="month" size="mini" clearable value-format="yyyy-MM" placeholder="所属月份">
        </el-date-picker>
        <label class="picker_name">审核状态：</label>
        <el-select class="picker_input" v-model="status" size='mini' @change="init(1)" clearable filterable placeholder="请选择审核状态">
          <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <template v-if="userInfo.role_id == 10 || userInfo.role_id == 18">
          <el-select v-model="pre_audit_status" @change="init(1)" style="width:150px;" size="mini"
            clearable placeholder="财务预审状态">
            <el-option v-for="(item, index) in pre_audit_list" :key="index" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </template>
        <el-input placeholder="请输入成本公司名称" v-model.trim="cost_company_name" clearable
          @keydown.enter.native="cost_company_name ? init(1) : ''" @clear="init(1)" size="mini"
          style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="cost_company_name ? init(1) : ''"
            style="padding:0 10px"></el-button>
        </el-input>
        <div class="batchVerifyBtn" v-if="[10,12,13].includes(userInfo.role_id)" @click="batchVerify">批量审核</div>
        <el-date-picker
          v-model="verify_cw_date"
          type="daterange"
          range-separator="至"
          start-placeholder="财务审核开始日期"
          end-placeholder="财务审核结束日期"
          value-format="yyyy-MM-dd"
          size="mini"
          style="width: 240px; margin-left:10px"
          @change="init(1)">
        </el-date-picker>
        <div class="batchVerifyBtn" @click="exportData" v-if="[10,12,1].includes(userInfo.role_id)">导出</div>
      </div>
    </div>
    <ux-grid class="uxGridBox" ref="plxTable" :height="height" 
      :checkbox-config="{ checkMethod: selectable, highlight: true }"
      @selection-change="selectionChange"
      show-footer-overflow="tooltip" show-overflow="tooltip" keep-source 
      :edit-config="{trigger: 'manual', mode: 'row'}" size="mini">
      <ux-table-column type="checkbox" align="center" fixed="left" width="40" v-if="[10,12,13,18].includes(userInfo.role_id)"/>
      <ux-table-column v-for="item in columns" :key="item.id" :resizable='true' :field="item.prop" :title="item.label" :width="item.width" show-header-overflow='tooltip' :fixed="item.fixed?item.fixed:''" align="center">
        <template v-slot="{ row }">
          <span v-if="item.prop == 'is_cash'">{{row.is_cash==1?'现金':row.is_cash==2?'授信':''}}</span>
          <span v-else-if="item.prop == 'is_flow_boost'">{{row.is_flow_boost==1?'是':row.is_flow_boost==2?'否':'-'}}</span>
          <span v-else-if="item.prop == 'media_name_list'">{{row.media_name_list && row.media_name_list.length ? row.media_name_list.join('、') : ''}}</span>
          <span v-else>{{row[item.prop]}}</span>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="预审结果" align="center" minWidth="80" fixed="right" field="describe" v-if="userInfo.role_id == 18 || userInfo.role_id == 10">
        <template v-slot="{ row }">
          <span v-if="row.pre_audit_status == 1" style="color:#00BB5D">通过</span>
          <span v-else-if="row.pre_audit_status == 2" style="color:red">驳回
            <el-popover placement="left-end" title="预审意见" width="400" trigger="hover" :content="row.pre_audit_content">
              <i class="el-icon-view" slot="reference" style="color: #202652;"></i>
            </el-popover>
          </span>
        </template>
      </ux-table-column>
      <ux-table-column :resizable='true' title="审核状态" align="center" minWidth="100" fixed="right" field="describe">
        <template v-slot="{ row }">
          <span v-if="row.status == 1">待媒介审核</span>
          <span v-else-if="row.status == 2">待财务审核</span>
          <span v-else-if="row.status == 3" style="color:red">媒介审核驳回</span>
          <span v-else-if="row.status == 4" style="color:#00BB5D">财务审核通过</span>
          <span v-else-if="row.status == 5" style="color:red">财务审核驳回</span>
          <span v-else-if="row.status == 6" style="color:#909399">已作废</span>
        </template>
      </ux-table-column>
      <ux-table-column title="操作" align="center" minWidth="160" fixed="right" field="describe">
        <template v-slot="{ row }">
          <div style="text-align:right">
            <span style="margin-right:5px;color:#5B7BFE;cursor: pointer;" v-if="(userInfo.role_id==13&&row.status==1)||((userInfo.role_id==18||userInfo.role_id==10)&&row.status==2)" @click="verifyEvent(row)">审核</span>
            <span style="margin-right:5px;color:#f66034;cursor: pointer;" v-if="(userInfo.role_id!=18&&userInfo.role_id!=10&&userInfo.role_id!=13)&&(row.status==1||row.status==2)" @click="delVerifyEvent(row)">撤销</span>
            <span style="margin-right:5px;color:#f66034;cursor: pointer;" v-if="Number(row.enable_void) === 1" @click="onClickVoid(row)">作废</span>
            <span style="margin-right:5px;color:#5B7BFE;cursor: pointer;" @click="downLoadCostApply(row)">下载</span>
          </div>
        </template>
      </ux-table-column>
    </ux-grid>
    <div class="paginationBox" style="height: 30px;">
      <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next, jumper" :total="total" />
    </div>
    <!-- 审核 -->
    <el-dialog title="审核" :visible.sync="verifyFlag" width="30%" :close-on-click-modal='false' center>
      <!-- 财务预审 -->
      <template v-if="userInfo.role_id == 18 && !selectedInfo.pre_audit_status">
        <div class="dialogBox" v-loading='verifyLoading'>
          <div class="dialogitem">
            <label>预审：</label>
            <el-radio-group v-model="preAudit.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
          </div>
          <div class="dialogitem" style="margin-top:20px">
            <label>预审意见：</label>
            <el-input style="margin-top:10px;width:100%" maxlength="300" type="textarea" :rows="2" placeholder="请输入审核意见" v-model="preAudit.content">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="preAuditSubmit" size="mini">提交</el-button>
        </span>
      </template>
      <!-- 财务预审结果 -->
      <template v-if="(selectedInfo.pre_audit_status && userInfo.role_id == 18) || userInfo.role_id == 10">
        <div class="dialogitem flex marB10">
          <label>预审：</label>
          <p>{{ selectedInfo.pre_audit_status == 1 ? '通过' : selectedInfo.pre_audit_status == 2 ? '驳回' : '' }}</p>
        </div>
        <div class="dialogitem flex marB10">
          <label>预审意见：</label>
          <p>{{ selectedInfo.pre_audit_content }}</p>
        </div>
      </template>
      <!-- 审核 -->
      <template v-if="userInfo.role_id != 18">
        <div class="dialogBox" v-loading='verifyLoading'>
          <div class="dialogitem">
            <label>审核意见：</label>
            <el-input style="margin-top:10px;width:100%" type="textarea" :rows="2" placeholder="请输入审核意见" v-model="verify_note">
            </el-input>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="costApplyVerifyEvent(1)" size="mini">审核驳回</el-button>
          <el-button type="primary" @click="costApplyVerifyEvent(2)" size="mini">审核通过</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- 批量审核弹窗 -->
    <el-dialog title="批量审核" :visible.sync="batchVerifyFlag" width="30%" :close-on-click-modal='false' center>
      <div class="dialogBox" v-loading='verifyLoading'>
        <div class="dialogitem">
          <label>审核意见：</label>
          <el-input style="margin-top:10px;width:100%" type="textarea" :rows="2" placeholder="请输入审核意见" v-model="verify_note">
          </el-input>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchVerifySubmit(1)" size="mini">审核驳回</el-button>
        <el-button type="primary" @click="batchVerifySubmit(2)" size="mini">审核通过</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { json2excel } from "@/assets/js/Export/setMethods.js"
import totalColumsJson from '@/components/Order/json/total.js'
export default {
  data () {
    return {
      height: 400,
      columns: [
        { prop: 'id', fixed: 'left', label: '序列号', width: '70' },
        { prop: 'month', fixed: 'left', label: '月份', width: '90' },
        { prop: 'cost_company_name', label: '成本公司全称', width: '100' },
        { prop: 'cost_sign_company', label: '成本签约公司', width: '100' },
        { prop: 'project_name', label: '项目名称', width: '100' },
        { prop: 'company', label: '签约公司', width: '100' },
        { prop: 'is_flow_boost', label: '是否流量助推', width: '100' },
        { prop: 'media_name_list', label: '媒体名称', width: '100' },
        { prop: 'is_cash', label: '授信/现金', width: '100' },
        { prop: 'tax_rate', label: '税率', width: '100' },
        { prop: 'invoice_date', label: '成本开票日期', width: '100' },
        { prop: 'confirmed_cost_includes_tax', label: '发票金额（含税）总计', width: '100' },
        { prop: 'confirmed_cost', label: '发票金额（不含税）总计', width: '100' },
        { prop: 'apply_user', label: '申请人', width: '100' },
        { prop: 'created_at', label: '申请时间', width: '100' },
        { prop: 'verify_user', label: '媒介审核人', width: '100' },
        { prop: 'verify_at', label: '媒介审核时间', width: '100' },
        { prop: 'verify_note', label: '媒介审核意见', width: '100' },
        { prop: 'verify_cw_user', label: '财务审核人', width: '100' },
        { prop: 'verify_cw_at', label: '财务审核时间', width: '100' },
        { prop: 'verify_cw_note', label: '财务审核意见', width: '100' },
      ],
      page: 1,
      page_size: 30,
      month: '',
      total: 0,
      status: '',
      statusList: [
        { id: '1', name: '待媒介审核' },
        { id: '2', name: '待财务审核' },
        { id: '3', name: '媒介审核驳回' },
        { id: '4', name: '财务审核通过' },
        { id: '5', name: '财务审核驳回' },
        { id: '6', name: '已作废' },
      ],
      userInfo: {},
      verifyFlag: false,
      verifyLoading: false,
      verify_note: '',
      verify_id: '',
      preAudit: {//财务预审
        status: '',
        content: ''
      },
      selectedInfo: {},
      pre_audit_status: '',
      pre_audit_list: [
        { label: '待审核', value: 0 },
        { label: '审核通过', value: 1 },
        { label: '审核驳回', value: 2 },
      ],
      cost_company_name: '',
      selectedRows: [],
      batchVerifyFlag: false,
      verify_cw_date: '',
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
  },
  mounted () {
    this.height = document.documentElement.clientHeight - 195 > 400 ? document.documentElement.clientHeight - 195 : 400
    this.init(1)
  },
  methods: {
    verifyEvent (row) {
      if ((this.userInfo.role_id == 13 && row.status == 1) || ((this.userInfo.role_id == 10 || this.userInfo.role_id == 18) && row.status == 2)) {
        this.verify_id = row.id;
        this.verifyFlag = true

        this.selectedInfo = row;
        this.preAudit.status = row.pre_audit_status;
        this.preAudit.content = row.pre_audit_content;
      }
    },
    /**提交预审 */
    preAuditSubmit(){
      if (this.preAudit.status == '' || !this.preAudit.status) {
        this.$message.warning('请选择预审结果')
        return
      }
      if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
        this.$message.warning('请输入审核意见')
        return
      }
      this.verifyLoading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
          type: 5,
          data_id_list: [ this.selectedInfo.id ],
          status: this.preAudit.status,
          content: this.preAudit.content,
      }).then((res) => {
          var res=res.data;
          this.verifyLoading = false;
          if(res&& res.errno == 0){
            this.verifyFlag = false;
            this.init(this.page)
          }else {
            this.$message({
                message: res.err,
                type: 'warning'
            })
          }
      }).catch(()=>{
          this.verifyLoading = false;
      })
    },
    handleCurrentChange (val) {
      this.selectedRows = []; // 清空已选数据
      this.init(val)
    },
    init (page) {
      this.page = page ? page : this.page;
      var params = {
        page: this.page,
        pagesize: this.page_size,
        month: this.month,
        status: this.status,
        pre_audit_status: this.pre_audit_status,
        cost_company_name: this.cost_company_name,
        verify_cw_date_start: this.verify_cw_date[0],
        verify_cw_date_end: this.verify_cw_date[1],
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.costInvoiceApplyList, {
        params
      }).then((res) => {
        var res = res.data;
        this.$loading(this.$loadingConfig).close()
        if (res && res.errno == 0) {
          var data = res.rst;
          this.total = data.pageInfo.total;
          this.datas = data.data // 知道为啥datas不在 data()方法里面定义吗？嘻嘻
          this.$refs.plxTable.reloadData(this.datas)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close()
      })
    },
    costApplyVerifyEvent (type) {
      var verify_status = '';
      if (type == 1) {//审核驳回
        if (this.userInfo.role_id == 13) {
          verify_status = 3
        }
        if (this.userInfo.role_id == 10) {
          verify_status = 5
        }
      }
      if (type == 2) {//审核通过
        if (this.userInfo.role_id == 13) {
          verify_status = 2
        }
        if (this.userInfo.role_id == 10) {
          verify_status = 4
        }
      }
      if (type == 1 && (this.verify_note == '' || !this.verify_note)) {
        this.$message({
          message: '请输入审核意见',
          type: 'warning'
        })
        return
      }
      this.verifyLoading = true
      this.$axios.post(this.URL.BASEURL + this.URL.costApplyVerify, {
        status: verify_status,
        id: this.verify_id,
        verify_note: this.verify_note
      }).then((res) => {
        var res = res.data;
        this.verifyLoading = false
        if (res && res.errno == 0) {
          this.verifyFlag = false;
          this.verify_note = '';
          this.verify_id = ''
          this.init(this.page)
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.verifyLoading = false
      })
    },
    delVerifyEvent (row) {//撤销申请
      this.$confirm('确定要撤销此次申请', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.delCostApply, {
          id: row.id
        }).then((res) => {
          this.$loading(this.$loadingConfig).close();
          var res = res.data;
          if (res && res.errno == 0) {
            this.init(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })
      }).catch((action) => {
      });
    },

    onClickVoid (row) {
      this.$prompt(
        '作废后将回退订单成本发票字段并写入记账修改记录，请确认操作。',
        '作废成本发票申请',
        {
          confirmButtonText: '确认作废',
          cancelButtonText: '取消',
          inputType: 'textarea',
          inputPlaceholder: '可选：填写作废备注',
          closeOnClickModal: false
        }
      ).then(({ value }) => {
        this.$loading(this.$loadingConfig);
        this.$axios.post(this.URL.BASEURL + this.URL.costApplyVoid, {
          id: row.id,
          void_note: value || ''
        }).then((res) => {
          this.$loading(this.$loadingConfig).close();
          const data = res.data || {};
          const isSuccess = data.errno == 0 || data.code == 0 || data.code == '0';
          if (isSuccess) {
            this.$message({
              message: data.err || data.msg || data.data || '作废成功',
              type: 'success'
            })
            this.init(this.page)
          } else {
            this.$message({
              message: data.err || data.msg || '作废失败',
              type: 'warning'
            })
          }
        }).catch(() => {
          this.$loading(this.$loadingConfig).close();
        })
      }).catch(() => {
        // user canceled
      })
    },
    downLoadCostApply (row) {//下载
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.costApplyDownload, {
        params: {
          id: row.id
        }
      }).then((res) => {
        var res = res.data;
        if (res && res.errno == 0) {
          var data = res.rst;
          data.forEach((item) => {
            item.is_cash = item.is_cash == 1 ? '现金' : item.is_cash == 2 ? '授信' : '';
            item.actual_cost_sum = Number(item.actual_cost_sum)
            item.traffic_boost_money = Number(item.traffic_boost_money)
          });
          var excelDatas = [
            {
              tHeader: ['任务ID', '订单月份', '签约公司', '授信/现金', '项目名称', '媒体名称', '成本开票日期', '成本公司全称', '成本签约公司', '后台实付成本金额', '流量助推(使用现金)'],
              filterVal: ['task_id', 'month', 'company', 'is_cash', 'project_name', 'media_name', 'cost_invoice_date', 'cost_company_name', 'cost_sign_company', 'actual_cost_sum', 'traffic_boost_money'],
              tableDatas: res.rst,
              sheetName: `${row.id} - 成本发票审核`
            },
          ]
          json2excel(excelDatas, `${row.id} - 成本发票审核`, true, "xlsx")//   引入的函数
          this.$loading(this.$loadingConfig).close();
        } else {
          this.$loading(this.$loadingConfig).close();
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.$loading(this.$loadingConfig).close();
      })

    },
    selectable(row) {
      // 根据用户角色和订单状态判断是否可选
      const status = row.row.status // 尝试获取状态值
      
      if (this.userInfo.role_id == 13 && status == 1) {
        return true; // 媒介审核人，待媒介审核状态可选
      }
      if ((this.userInfo.role_id == 10 || this.userInfo.role_id == 18) && status == 2) {
        return true; // 财务审核人，待财务审核状态可选
      }
      return false;
    },
    selectionChange (rows) {
      this.selectedRows = rows;
    },
    batchVerify() {
      if (!this.selectedRows || this.selectedRows.length === 0) {
        this.$message({
          message: '请选择要审核的订单',
          type: 'warning'
        });
        return;
      }
      this.batchVerifyFlag = true;
    },
    batchVerifySubmit(type) {
      if (type == 1 && (!this.verify_note || this.verify_note.trim() === '')) {
        this.$message({
          message: '请输入审核意见',
          type: 'warning'
        });
        return;
      }

      let verify_status = '';
      if (type == 1) {
        if (this.userInfo.role_id == 13) {
          verify_status = 3;
        }
        if (this.userInfo.role_id == 10 || this.userInfo.role_id == 12) {
          verify_status = 5;
        }
      }
      if (type == 2) {
        if (this.userInfo.role_id == 13) {
          verify_status = 2;
        }
        if (this.userInfo.role_id == 10 || this.userInfo.role_id == 12) {
          verify_status = 4;
        }
      }

      const id_list = this.selectedRows.map(row => row.id);
      
      this.verifyLoading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.costApplyBatchVerify, {
        id_list,
        status: verify_status,
        verify_note: this.verify_note
      }).then((res) => {
        this.verifyLoading = false;
        const response = res.data;
        if (response.errno == '0') {
          this.$message({
            message: '批量审核成功',
            type: 'success'
          });
          this.batchVerifyFlag = false;
          this.verify_note = '';
          this.init(this.page);
        } else if (response.errno == '1110' || response.errno == '1111') {
          this.$alert(`异常序列号：${response.rst.join(',')}`, response.err, {
            confirmButtonText: '确定',
            callback: action => {
              this.batchVerifyFlag = false;
              this.verify_note = '';
              this.init(this.page);
            }
          });
        } else {
          this.$message({
            message: response.err,
            type: 'warning'
          });
        }
      }).catch(() => {
        this.verifyLoading = false;
        this.$message({
          message: '批量审核失败',
          type: 'error'
        });
      });
    },
    exportData() {
      if (!this.verify_cw_date || this.verify_cw_date.length === 0) {
        this.$message({
          message: '请选择财务审核日期范围',
          type: 'warning'
        });
        return;
      }
      this.$loading(this.$loadingConfig);
      this.$axios.get(this.URL.BASEURL + this.URL.costInvoiceExport, {
        params: {
          verify_cw_date_start: this.verify_cw_date[0],
          verify_cw_date_end: this.verify_cw_date[1],
          month: this.month,
          status: this.status,
          pre_audit_status: this.pre_audit_status,
          cost_company_name: this.cost_company_name
        },
        responseType: 'blob' // 关键：指定响应类型为二进制流
      }).then((res) => {
        this.$loading(this.$loadingConfig).close();
        if (res.data.type === 'application/json') {
          // 如果返回的是json，说明可能报错了（例如没有权限或参数错误），需要读取blob转json
          const reader = new FileReader();
          reader.onload = () => {
             const result = JSON.parse(reader.result);
             this.$message({
                message: result.err || '导出失败',
                type: 'warning'
             })
          };
          reader.readAsText(res.data);
          return;
        }
        
        // 正常下载文件
        const content = res.data;
        const blob = new Blob([content]);
        const fileName = `成本发票订单明细_${this.verify_cw_date[0]}至${this.verify_cw_date[1]}.xlsx`
        
        if ('download' in document.createElement('a')) { // 非IE下载
          const elink = document.createElement('a')
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = URL.createObjectURL(blob)
          document.body.appendChild(elink)
          elink.click()
          URL.revokeObjectURL(elink.href) // 释放URL 对象
          document.body.removeChild(elink)
        } else { // IE10+下载
          navigator.msSaveBlob(blob, fileName)
        }
      }).catch((err) => {
        console.error(err)
        this.$loading(this.$loadingConfig).close();
        this.$message({
          message: '导出请求异常',
          type: 'error'
        });
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.platform_div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 10px 20px;
  background: #fff;
}
.picker_name {
  font-size: 13px;
  color: #444;
  margin-left: 10px;
}
.picker_input {
  width: 160px;
}
.marB10{
  margin-bottom: 10px;
}
.batchVerifyBtn {
  height: 32px;
  line-height: 32px;
  padding: 0 15px;
  font-size: 12px;
  text-align: center;
  border-radius: 4px;
  background: #5B7BFE;
  color: #fff;
  cursor: pointer;
  display: inline-block;
  margin-left: 10px;
  
  &:hover {
    opacity: 0.9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/examine/costInvoiceApplyList.vue